<template>
  <div>
    <a :href="href">{{datax}}</a>
  </div>
</template>

<script>
  export default {
    props: {
      datax: {
        type: [Number, String]
      },
      href: {
        type: String
      }
    }
  }
</script>
<style>

</style>

